module.exports = __webpack_public_path__ + "img/图标-AI小助手2.53cbf5b3.png";